import { render, staticRenderFns } from "./small-banner.vue?vue&type=template&id=59f541a4&scoped=true&"
import script from "./small-banner.vue?vue&type=script&lang=js&"
export * from "./small-banner.vue?vue&type=script&lang=js&"
import style0 from "./small-banner.vue?vue&type=style&index=0&id=59f541a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f541a4",
  null
  
)

export default component.exports